module.exports = __webpack_public_path__ + "img/story-itinerary-icon.1ec83538.svg";